import { render, staticRenderFns } from "./ModalHost.vue?vue&type=template&id=5bf66431&scoped=true"
import script from "./ModalHost.vue?vue&type=script&lang=js"
export * from "./ModalHost.vue?vue&type=script&lang=js"
import style0 from "./ModalHost.vue?vue&type=style&index=0&id=5bf66431&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5bf66431",
  null
  
)

export default component.exports